import {
  FETCH_MESSAGES_REQUEST,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAILURE,
  SET_MESSAGE_READ,
  SET_MESSAGE_UNREAD,
  SET_MESSAGE_ACCESS,
  SET_MESSAGE_PASSWORD,
  SET_MESSAGE_SENT,
  MOVE_MESSAGE_TO_RECIPIENTFOLDER,
  MOVE_MESSAGE_TO_SENDERFOLDER,
  ADD_MESSAGE,
  ANSWER_MESSAGE,
  DELETE_MESSAGE,
  SAVE_MESSAGE,
  SAVE_MESSAGE_RECIPIENTS,
  SAVE_DRAFT_MESSAGE,
  UPDATE_DRAFT_MESSAGE,
  DELETE_DRAFT_MESSAGE,
  UPDATE_DRAFT_RECIPIENTS,
  ADD_MESSAGE_ID,
  REMOVE_MESSAGE_ID,
  SELECT_MESSAGE_ID,
  UNSELECT_MESSAGE_ID,
  CLEAR_MESSAGE_IDS
} from "actions/types";

import {
  messages,
  setMessageRead,
  setMessageUnread,
  setMessageAccess,
  setMessagePassword,
  assignRecipientMessageFolder,
  assignSenderMessageFolder,
  insMessage,
  reMessage,
  delMessage,
  storeMessage,
  messageSend,
  messageSystemSend,
  storeMessageRecipients,
} from "../api";

export const fetchMessagesRequest = () => {
  return {
    type: FETCH_MESSAGES_REQUEST,
  };
};

const fetchMessagesSuccess = (messages) => {
  return {
    type: FETCH_MESSAGES_SUCCESS,
    payload: messages,
    // userId,
  };
};

const fetchMessagesFailure = (error) => {
  return {
    type: FETCH_MESSAGES_FAILURE,
    payload: error,
  };
};

export const fetchMessages = (userId) => {
  return async (dispatch) => {
    await dispatch(fetchMessagesRequest());
    try {
      const messagesJSONData = await dispatch(messages(userId));
      await dispatch(fetchMessagesSuccess(messagesJSONData));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const setReadData = (values) => {
  return {
    type: SET_MESSAGE_READ,
    payload: values,
  };
};

export const setRead = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(setMessageRead(values));
      await dispatch(setReadData(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const setUnreadData = (values) => {
  return {
    type: SET_MESSAGE_UNREAD,
    payload: values,
  };
};

export const setUnread = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(setMessageUnread(values));
      await dispatch(setUnreadData(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const setAccessData = (values) => {
  return {
    type: SET_MESSAGE_ACCESS,
    payload: values,
  };
};

export const setAccessCompleted = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(setMessageAccess(values));
      await dispatch(setAccessData(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};
const setNewPasswordData = (values) => {
  return {
    type: SET_MESSAGE_PASSWORD,
    payload: values,
  };
};

export const setNewPasswordCompleted = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(setMessagePassword(values));
      await dispatch(setNewPasswordData(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const sendMessageData = (values) => {
  return {
    type: SET_MESSAGE_SENT,
    payload: values,
  };
};

export const sendMessage = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(messageSend({ id: id }));
      await dispatch(sendMessageData(id));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

export const sendSystemMessage = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(messageSystemSend(values));
      await dispatch(sendMessageData(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const assignRecipientFolderToMessage = (values) => {
  return {
    type: MOVE_MESSAGE_TO_RECIPIENTFOLDER,
    payload: values,
  };
};

export const setRecipientMessageFolder = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(assignRecipientMessageFolder(values));
      await dispatch(assignRecipientFolderToMessage(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const assignSenderFolderToMessage = (values) => {
  return {
    type: MOVE_MESSAGE_TO_SENDERFOLDER,
    payload: values,
  };
};

export const setSenderMessageFolder = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(assignSenderMessageFolder(values));
      await dispatch(assignSenderFolderToMessage(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const addMessageSuccess = (values) => {
  return {
    type: ADD_MESSAGE,
    payload: {
      id: values.id,
      fromUserId: values.userId,
      toMode: "0",
      senderFolderId: "-5",
      recipientFolderId: "-3",
      title: "",
      message: "",
      recipients: [],
    },
  };
};

export const addMessage = (userId) => {
  return async (dispatch) => {
    try {
      const messagesJSONData = await dispatch(insMessage({ userId: userId }));
      await dispatch(addMessageSuccess({ userId, id: messagesJSONData }));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const addMessageRecipientsSuccess = (values) => {
  return {
    type: SAVE_MESSAGE_RECIPIENTS,
    payload: values,
  };
};

export const addMessageRecipients = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(storeMessageRecipients(values));
      await dispatch(addMessageRecipientsSuccess(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const answerMessageSuccess = (values) => {
  return {
    type: ANSWER_MESSAGE,
    payload: values,
  };
};

export const answerMessage = (values) => {
  return async (dispatch) => {
    try {
      const messagesJSONData = await dispatch(reMessage(values));
      await dispatch(answerMessageSuccess(messagesJSONData));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const deleteMessageData = (id) => {
  return {
    type: DELETE_MESSAGE,
    payload: id,
  };
};

export const deleteMessage = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(delMessage({ id: id }));
      await dispatch(deleteMessageData(id));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const saveMessageSuccess = (values) => {
  return {
    type: SAVE_MESSAGE,
    payload: values,
  };
};

export const saveMessage = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(storeMessage(values));
      await dispatch(saveMessageSuccess(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const updateDraftMessageSuccess = (values) => {
  return {
    type: UPDATE_DRAFT_MESSAGE,
    payload: values,
  };
};

export const updateDraftMessage = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(updateDraftMessageSuccess(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const deleteDraftMessageSuccess = () => {
  return {
    type: DELETE_DRAFT_MESSAGE,
  };
};

export const deleteDraftMessage = () => {
  return async (dispatch) => {
    try {
      await dispatch(deleteDraftMessageSuccess());
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const updateDraftRecipientsSuccess = (values) => {
  return {
    type: UPDATE_DRAFT_RECIPIENTS,
    payload: values,
  };
};

export const updateDraftRecipients = (values) => {
  return async (dispatch) => {
    try {
      await dispatch(updateDraftRecipientsSuccess(values));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const saveDraftMessageSuccess = (values) => {
  return {
    type: SAVE_DRAFT_MESSAGE,
    payload: values,
  };
};

export const saveDraftMessage = () => {
  return async (dispatch, getState) => {
    const values = getState().messages.draftMessage;
    try {
      await dispatch(storeMessage(values));
      await dispatch(saveDraftMessageSuccess(values));
      await dispatch(storeMessageRecipients(values.recipients));
      await dispatch(addMessageRecipientsSuccess(values.recipients));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const addMessageIdData = (value) => {
  return {
    type: ADD_MESSAGE_ID,
    payload: value,
  };
};

export const addMessageId = (value) => {
  return async (dispatch) => {
    try {
      await dispatch(addMessageIdData(value));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const removeMessageIdData = (value) => {
  return {
    type: REMOVE_MESSAGE_ID,
    payload: value,
  };
};

export const removeMessageId = (value) => {
  return async (dispatch) => {
    try {
      await dispatch(removeMessageIdData(value));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const selectMessageIdData = (value) => {
  return {
    type: SELECT_MESSAGE_ID,
    payload: value,
  };
};

export const selectMessageId = (value) => {
  return async (dispatch) => {
    try {
      await dispatch(selectMessageIdData(value));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const unselectMessageIdData = (value) => {
  return {
    type: UNSELECT_MESSAGE_ID,
    payload: value,
  };
};

export const unselectMessageId = (value) => {
  return async (dispatch) => {
    try {
      await dispatch(unselectMessageIdData(value));
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};

const clearMessageIdData = () => {
  return {
    type: CLEAR_MESSAGE_IDS,
  };
};

export const clearMessageIds = () => {
  return async (dispatch) => {
    try {
      await dispatch(clearMessageIdData());
    } catch (err) {
      await dispatch(fetchMessagesFailure(err));
    }
  };
};